import { render } from "./EventList.vue?vue&type=template&id=59656830"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=59656830&lang=scss"
script.render = render

export default script